import React, { useLayoutEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { X } from "@phosphor-icons/react";
import "./slider.css";
const ImageSliderModal = ({ images, onClose }) => {
  return (
    <div className="fixed inset-0 z-[2000] bg-[#00000097] flex items-center justify-center h-[100vh] ">
      <div className="relative mt-[10vh] w-[90%] lg:w-[60%] p-4 bg-black rounded-lg">
        {/* Close button */}
        <button
          className="absolute top-2 right-2 text-white bg-white px-4 py-2 rounded-xl z-[1000] text-lg"
          onClick={onClose}
        >
          <X color="black" weight="bold" />
        </button>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          navigation={{
            clickable: true,
          }}
          speed={1000}
          modules={[Navigation]}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                alt=""
                src={image}
                className="w-full lg:w-3/4 h-full mx-auto"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ImageSliderModal;
